<template>
  <b-form @submit.stop.prevent="sendForm" @reset="onReset">
  <b-container class="search pb-3 d-none d-sm-block">
    <b-row align-h="center" class="mt-4" v-if="search==='true'">
      <b-col cols='12' class="banner">
        <b-row align-h="center" class="mt-5">
          <b-col lg='7' md='8' sm='9' cols='8'>
            <span class="title-regular">Conoce los </span>
            <span class="title-bold">beneficios gratuitos que Entel </span>
            <span class="title-regular">tiene para ti ingresando tu </span>
            <span class="title-semibold">n&uacute;mero m&oacute;vil corporativo:</span>
          </b-col>
          <b-col lg='4' md='4' sm='3' cols='3'></b-col>
        </b-row>
        <b-row align-h="center" class="mt-4">
          <b-col lg='7' md='8' sm='9' cols='8'>
            <b-row>
              <b-col lg='8' md='8' sm='7' cols='8'>
                <b-input-group size="md" prepend="(+56)" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input id="employeePhone" v-model="$v.form.employeePhone.$model" placeholder="Teléfono"
                  :state="validateState('employeePhone')" @focus="setFocusElement('employeePhone')" @blur="setBlurElement('employeePhone')" aria-describedby="input-employeePhone" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-employeePhone">Campo requerido, debe contener 9 dígitos. Ej: 995123456</b-form-invalid-feedback>
                </b-input-group>
              </b-col>
              <b-col lg='4' md='4' sm='4' cols='4'>
                <b-button type="submit" size='sm' class="btn btn-primary" :disabled="$v.form.$invalid || this.formSent">
                  <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="this.formSent"></span>
                  Consultar
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg='12' md='12' sm='11' cols='12'>
                <b-alert :show="dismissCountDown" dismissible :variant="message.class" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged" class="mt-4">
                  <p>{{message.text}}</p>
                  <b-progress :variant="message.class" :max="message.seconds" :value="dismissCountDown" height="4px"></b-progress>
                </b-alert>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg='4' md='4' sm='3' cols='3'></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-4"  v-if="search==='true'">
      <b-col cols='12' class="text-center">
        <span class="desc-regular">Te </span>
        <span class="desc-bold">Conecto</span>
      </b-col>
      <b-col cols='12' class="text-center">
        <span class="desc-regular">Acercando soluciones a trav&eacute;s de la tecnolog&iacute;a</span>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-4">
      <b-row align-v="stretch">
        <b-col class="ml-3 mr-3 rounded-lg card zoom">
          <b-img :src="require('../assets/img/img-card-01.png')" alt="Medismart-Back" fluid-grow></b-img>
          <b-row class="mb-4" align-h="center">
            <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
              <b-img :src="require('../assets/img/logo-card-01.png')" alt="Medismart-Logo" fluid-grow></b-img>
            </b-col>
          </b-row>
          <b-row class="mt-4" align-h="center">
            <b-col class="text-center" lg='12' md='12' sm='9' cols='12'>
              <b-img class="mr-2" :src="require('../assets/img/icon-card-01.png')" alt="Medismart-Icon"></b-img>
              <span class="card-bold-1">TeConecto </span>
              <span class="card-bold-2">Salud Digital</span>
            </b-col>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3" align-h="center" v-if="!showLayer">
            <b-col class="card-text text-center" cols='12'>
              <span class="card-regular">
                Consultas m&eacute;dicas online ilimitadas brindadas por especialistas y m&eacute;dicos certificados
              </span>
            </b-col>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3" align-h="center" v-if="showLayer">
            <b-badge pill variant="primary">
              <span class="card-semibold-1">100% </span>
              <span class="card-semibold-2">Dcto</span>
            </b-badge>
            <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
              <span class="card-bold-2">100% Dcto </span>
              <span class="card-regular">en Telemedicina de Medismart.</span>
            </b-col>
          </b-row>
          <b-row class="mt-4" align-h="center">
            <b-col class="text-center" cols='12'>
              <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/salud-digital/')">
                Ver más
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="ml-3 mr-3 rounded-lg card zoom">
          <b-img :src="require('../assets/img/img-card-02.png')" alt="Misabogados-Back" fluid-grow></b-img>
          <b-row class="mb-4" align-h="center">
            <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
              <b-img :src="require('../assets/img/logo-card-02.png')" alt="Misabogados-Logo" fluid-grow></b-img>
            </b-col>
          </b-row>
          <b-row class="mt-4" align-h="center">
            <b-col class="text-center" lg='12' md='12' sm='10' cols='12'>
              <b-img class="mr-2" :src="require('../assets/img/icon-card-02.png')" alt="Misabogados-Icon"></b-img>
              <span class="card-bold-1">TeConecto </span>
              <span class="card-bold-2">Ayuda Legal</span>
            </b-col>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3" align-h="center" v-if="!showLayer">
            <b-col class="card-text text-center" cols='12'>
              <span class="card-regular">
                Asesor&iacute;a legal desde cualquier dispositivo brindada por expertos.
              </span>
            </b-col>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3" align-h="center" v-if="showLayer">
            <b-badge pill variant="primary">
              <span class="card-semibold-1">100% </span>
              <span class="card-semibold-2">Dcto</span>
            </b-badge>
            <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
              <span class="card-bold-2">100% Dcto </span>
              <span class="card-regular">en Ayuda Legal de MisAbogados.</span>
            </b-col>
          </b-row>
          <b-row class="mt-4" align-h="center">
            <b-col class="text-center" cols='12'>
              <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/asesoria-legal-digital/')">
                Ver más
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="ml-3 mr-3 rounded-lg card zoom">
          <b-img :src="require('../assets/img/img-card-03.png')" alt="Bcnschool-back" fluid-grow></b-img>
          <b-row class="mb-4" align-h="center">
            <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
              <b-img :src="require('../assets/img/logo-card-03.png')" alt="Bcnschool-Logo" fluid-grow></b-img>
            </b-col>
          </b-row>
          <b-row class="mt-4" align-h="center">
            <b-col class="text-center" lg='12' md='12' sm='9' cols='12'>
              <b-img class="mr-2" :src="require('../assets/img/icon-card-03.png')" alt="Bcnschool-Icon"></b-img>
              <span class="card-bold-1">TeConecto </span>
              <span class="card-bold-2">E-Learning</span>
            </b-col>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3" align-h="center" v-if="!showLayer">
            <b-col class="card-text text-center" cols='12'>
              <span class="card-regular">
                Cursos online y acceso adiplomados certificados
              </span>
            </b-col>
          </b-row>
          <b-row class="mt-3 pl-3 pr-3" align-h="center" v-if="showLayer">
            <b-badge pill variant="primary">
              <span class="card-semibold-1">100% </span>
              <span class="card-semibold-2">Dcto</span>
            </b-badge>
            <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
              <span class="card-bold-2">100% Dcto </span>
              <span class="card-regular">en cursos e-learning de BCN School.</span>
            </b-col>
          </b-row>
          <b-row class="mt-4" align-h="center">
            <b-col class="text-center" cols='12'>
              <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/e-learning/')">
                Ver más
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-row>
  </b-container>
  <b-container class="search-mobile d-sm-none">
    <b-row align-h="center">
      <b-col cols='12' class="banner-mobile pt-5 pb-5"  v-if="search==='true'">
        <b-row class="mt-5 pt-3">
          <b-col cols='12'>
            <span class="titlem-regular">Conoce los </span>
            <span class="titlem-bold">beneficios gratuitos que Entel </span>
            <span class="titlem-regular">tiene para ti ingresando tu </span>
            <span class="titlem-semibold">n&uacute;mero m&oacute;vil corporativo:</span>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3">
          <b-col cols='8'>
            <b-row align-h="center" class="mb-2">
              <b-col cols='12'>
                <b-input-group size="md" prepend="(+56)" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input id="employeePhone" v-model="$v.form.employeePhone.$model" placeholder="Teléfono"
                  :state="validateState('employeePhone')" @focus="setFocusElement('employeePhone')" @blur="setBlurElement('employeePhone')" aria-describedby="input-employeePhone" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-employeePhone">Campo requerido, debe contener 9 dígitos. Ej: 995123456</b-form-invalid-feedback>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mb-2">
              <b-col cols='12' class="text-center">
                <b-button type="submit" size='sm' class="btn btn-primary" :disabled="$v.form.$invalid || this.formSent">
                  <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="this.formSent"></span>
                  Consultar
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3">
          <b-col cols='12'>
            <b-alert :show="dismissCountDown" dismissible :variant="message.class" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
              <p>{{message.text}}</p>
              <b-progress :variant="message.class" :max="message.seconds" :value="dismissCountDown" height="4px"></b-progress>
            </b-alert>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3 mb-3">
          <b-col cols='10' class="text-center">
            <span class="descm-regular">Te </span>
            <span class="descm-bold">Conecto</span>
          </b-col>
          <b-col cols='10' class="text-center">
            <span class="descm-regular">Acercando soluciones a trav&eacute;s de la tecnolog&iacute;a</span>
          </b-col>
        </b-row>
        <b-row>
          <b-carousel fade v-model="slide" :interval="interval" :controls="controls" :indicators="indicators" background="#fff" :img-height="imgHeight" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
            <b-carousel-slide caption="" img-blank>
              <b-col class="rounded-lg card">
                <b-img :src="require('../assets/img/img-card-01.png')" alt="Medismart-Back" fluid-grow></b-img>
                <b-row class="mb-4" align-h="center">
                  <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
                    <b-img :src="require('../assets/img/logo-card-01.png')" alt="Medismart-Logo" fluid-grow></b-img>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" lg='12' md='12' sm='9' cols='12'>
                    <b-img class="mr-2" :src="require('../assets/img/icon-card-01.png')" alt="Medismart-Icon"></b-img>
                    <span class="card-bold-1">TeConecto </span>
                    <span class="card-bold-2">Salud Digital</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2" align-h="center" v-if="!showLayer">
                  <b-col class="card-text text-center" cols='12'>
                    <span class="card-regular-1">
                      Consultas m&eacute;dicas online ilimitadas brindadas por especialistas y m&eacute;dicos certificados
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2 card-row" align-h="center" v-if="showLayer">
                  <b-badge pill variant="primary">
                    <span class="card-semibold-1">100% </span>
                    <span class="card-semibold-2">Dcto</span>
                  </b-badge>
                  <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
                    <span class="card-bold-4">100% Dcto </span>
                    <span class="card-regular-2">en Telemedicina de Medismart.</span>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" cols='12'>
                    <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/salud-digital/')">
                      Ver más
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-carousel-slide>
            <b-carousel-slide caption="" img-blank>
              <b-col class="rounded-lg card">
                <b-img :src="require('../assets/img/img-card-02.png')" alt="Misabogados-Back" fluid-grow></b-img>
                <b-row class="mb-4" align-h="center">
                  <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
                    <b-img :src="require('../assets/img/logo-card-02.png')" alt="Misabogados-Logo" fluid-grow></b-img>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" lg='12' md='12' sm='10' cols='12'>
                    <b-img class="mr-2" :src="require('../assets/img/icon-card-02.png')" alt="Misabogados-Icon"></b-img>
                    <span class="card-bold-1">TeConecto </span>
                    <span class="card-bold-2">Ayuda Legal</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2" align-h="center" v-if="!showLayer">
                  <b-col class="card-text text-center" cols='12'>
                    <span class="card-regular-1">
                      Asesor&iacute;a legal desde cualquier dispositivo brindada por expertos.
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2 card-row" align-h="center" v-if="showLayer">
                  <b-badge pill variant="primary">
                    <span class="card-semibold-1">100% </span>
                    <span class="card-semibold-2">Dcto</span>
                  </b-badge>
                  <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
                    <span class="card-bold-4">100% Dcto </span>
                    <span class="card-regular-2">en Ayuda Legal de MisAbogados.</span>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" cols='12'>
                    <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/asesoria-legal-digital/')">
                      Ver más
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-carousel-slide>
            <b-carousel-slide caption="" img-blank>
              <b-col class="rounded-lg card">
                <b-img :src="require('../assets/img/img-card-03.png')" alt="Bcnschool-back" fluid-grow></b-img>
                <b-row class="mb-4" align-h="center">
                  <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
                    <b-img :src="require('../assets/img/logo-card-03.png')" alt="Bcnschool-Logo" fluid-grow></b-img>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" lg='12' md='12' sm='9' cols='12'>
                    <b-img class="mr-2" :src="require('../assets/img/icon-card-03.png')" alt="Bcnschool-Icon"></b-img>
                    <span class="card-bold-1">TeConecto </span>
                    <span class="card-bold-2">E-Learning</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2" align-h="center" v-if="!showLayer">
                  <b-col class="card-text text-center" cols='12'>
                    <span class="card-regular-1">
                      Cursos online y acceso adiplomados certificados
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2 card-row" align-h="center" v-if="showLayer">
                  <b-badge pill variant="primary">
                    <span class="card-semibold-1">100% </span>
                    <span class="card-semibold-2">Dcto</span>
                  </b-badge>
                  <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
                    <span class="card-bold-4">100% Dcto </span>
                    <span class="card-regular-2">en cursos e-learning de BCN School.</span>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" cols='12'>
                    <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/e-learning/')">
                      Ver más
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-carousel-slide>
          </b-carousel>
        </b-row>
      </b-col>
      <b-col cols='12' class="pt-5 pb-5"  v-if="search==='false'">
        <b-row>
          <b-carousel fade v-model="slide" :interval="interval" :controls="controls" :indicators="indicators" background="#fff" :img-height="imgHeight" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
            <b-carousel-slide caption="" img-blank>
              <b-col class="rounded-lg card">
                <b-img :src="require('../assets/img/img-card-01.png')" alt="Medismart-Back" fluid-grow></b-img>
                <b-row class="mb-4" align-h="center">
                  <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
                    <b-img :src="require('../assets/img/logo-card-01.png')" alt="Medismart-Logo" fluid-grow></b-img>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" lg='12' md='12' sm='9' cols='12'>
                    <b-img class="mr-2" :src="require('../assets/img/icon-card-01.png')" alt="Medismart-Icon"></b-img>
                    <span class="card-bold-1">TeConecto </span>
                    <span class="card-bold-2">Salud Digital</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2" align-h="center" v-if="!showLayer">
                  <b-col class="card-text text-center" cols='12'>
                    <span class="card-regular-1">
                      Consultas m&eacute;dicas online ilimitadas brindadas por especialistas y m&eacute;dicos certificados
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2 card-row" align-h="center" v-if="showLayer">
                  <b-badge pill variant="primary">
                    <span class="card-semibold-1">100% </span>
                    <span class="card-semibold-2">Dcto</span>
                  </b-badge>
                  <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
                    <span class="card-bold-4">100% Dcto </span>
                    <span class="card-regular-2">en Telemedicina de Medismart.</span>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" cols='12'>
                    <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/salud-digital/')">
                      Ver más
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-carousel-slide>
            <b-carousel-slide caption="" img-blank>
              <b-col class="rounded-lg card">
                <b-img :src="require('../assets/img/img-card-02.png')" alt="Misabogados-Back" fluid-grow></b-img>
                <b-row class="mb-4" align-h="center">
                  <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
                    <b-img :src="require('../assets/img/logo-card-02.png')" alt="Misabogados-Logo" fluid-grow></b-img>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" lg='12' md='12' sm='10' cols='12'>
                    <b-img class="mr-2" :src="require('../assets/img/icon-card-02.png')" alt="Misabogados-Icon"></b-img>
                    <span class="card-bold-1">TeConecto </span>
                    <span class="card-bold-2">Ayuda Legal</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2" align-h="center" v-if="!showLayer">
                  <b-col class="card-text text-center" cols='12'>
                    <span class="card-regular-1">
                      Asesor&iacute;a legal desde cualquier dispositivo brindada por expertos.
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2 card-row" align-h="center" v-if="showLayer">
                  <b-badge pill variant="primary">
                    <span class="card-semibold-1">100% </span>
                    <span class="card-semibold-2">Dcto</span>
                  </b-badge>
                  <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
                    <span class="card-bold-4">100% Dcto </span>
                    <span class="card-regular-2">en Ayuda Legal de MisAbogados.</span>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" cols='12'>
                    <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/asesoria-legal-digital/')">
                      Ver más
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-carousel-slide>
            <b-carousel-slide caption="" img-blank>
              <b-col class="rounded-lg card">
                <b-img :src="require('../assets/img/img-card-03.png')" alt="Bcnschool-back" fluid-grow></b-img>
                <b-row class="mb-4" align-h="center">
                  <b-col class="logo-card" lg='5' md='6' sm='8' cols='6'>
                    <b-img :src="require('../assets/img/logo-card-03.png')" alt="Bcnschool-Logo" fluid-grow></b-img>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" lg='12' md='12' sm='9' cols='12'>
                    <b-img class="mr-2" :src="require('../assets/img/icon-card-03.png')" alt="Bcnschool-Icon"></b-img>
                    <span class="card-bold-1">TeConecto </span>
                    <span class="card-bold-2">E-Learning</span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2" align-h="center" v-if="!showLayer">
                  <b-col class="card-text text-center" cols='12'>
                    <span class="card-regular-1">
                      Cursos online y acceso adiplomados certificados
                    </span>
                  </b-col>
                </b-row>
                <b-row class="mt-3 pl-2 pr-2 card-row" align-h="center" v-if="showLayer">
                  <b-badge pill variant="primary">
                    <span class="card-semibold-1">100% </span>
                    <span class="card-semibold-2">Dcto</span>
                  </b-badge>
                  <b-col class="text-center" lg='11' md='12' sm='12' cols='12'>
                    <span class="card-bold-4">100% Dcto </span>
                    <span class="card-regular-2">en cursos e-learning de BCN School.</span>
                  </b-col>
                </b-row>
                <b-row class="mt-4" align-h="center">
                  <b-col class="text-center" cols='12'>
                    <b-button type="button" size='sm' class="btn btn-custom" v-on:click="goTo('https://www.entel.cl/corporaciones/employee/colaboradores/e-learning/')">
                      Ver más
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-carousel-slide>
          </b-carousel>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
  </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  props: {
    search: String
  },
  data () {
    return {
      slide: 0,
      sliding: null,
      controls: true,
      indicators: false,
      interval: 0,
      imgHeight: 610,
      token: null,
      form: {
        employeePhone: null
      },
      valid: {
        employeePhone: null
      },
      message: {
        text: '',
        class: '',
        success: 0
      },
      dismissCountDown: 0,
      focusElement: null,
      blurElement: null,
      formSent: false,
      showLayer: false,
      seconds: 5
    }
  },
  validations: {
    form: {
      employeePhone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
        validatePhone (employeePhone) {
          return /9[0-9]{8}$/.test(employeePhone)
        }
      }
    }
  },
  computed: {
    validateForm () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    setFocusElement (focusElement) {
      this.focusElement = focusElement
    },
    setBlurElement (blurElement) {
      this.blurElement = blurElement
    },
    validateState (name) {
      let validated = null
      const { $dirty, $error } = this.$v.form[name]
      if (this.blurElement === name) {
        this.valid[name] = true
      }
      validated = ((this.valid[name] === true) && $dirty) ? !$error : null
      return validated
    },
    sendForm () {
      let url = 'requests/phones/check'
      this.showLayer = false
      this.$v.form.$touch()
      if (!this.$v.form.$anyError) {
        this.formSent = true
        this.$http({
          url: 'authenticate',
          method: 'post',
          baseURL: this.$apiUrl,
          data: this.$apiUser
        })
          .then(response => {
            this.token = response.data.token
            let data = {}
            data = this.form
            let promise = this.$http({
              url: url,
              method: 'post',
              baseURL: this.$apiUrl,
              headers: {
                'Authorization': this.token
              },
              data: data
            })
            return promise.then(
              (resp) => {
                this.formSent = true
                let data = resp.data
                if (data.data.success === 1) {
                  if (data.data.match === 1) {
                    this.showLayer = true
                    this.message.text = '¡Puedes disfrutar de estos beneficios exclusivos para ti!'
                    this.message.class = 'info'
                    this.message.seconds = this.seconds
                    this.message.success = data.data.success
                  } else {
                    this.message.text = data.message
                    this.message.class = 'warning'
                    this.message.seconds = this.seconds
                    this.message.success = data.data.match
                  }
                  this.showAlert()
                  setTimeout(this.buttonActive, this.seconds * 1000)
                } else {
                  this.message.text = '¡Lo sentimos ☹! Tu línea no cuenta con beneficios actualmente.'
                  this.message.class = 'warning'
                  this.message.seconds = this.seconds
                  this.message.success = data.data.success
                  this.showAlert()
                  setTimeout(this.buttonActive, this.seconds * 1000)
                }
              },
              (error) => {
                console.log(error)
                this.message.text = 'Disculpe, hubo un error al procesar formulario code[1]'
                this.message.class = 'warning'
                this.message.seconds = this.seconds
                this.message.success = 1
                this.showAlert()
                setTimeout(this.buttonActive, this.seconds * 1000)
              }
            ).catch((error) => {
              console.log(error)
              this.message.text = 'Disculpe, hubo un error al procesar formulario code[2]'
              this.message.class = 'warning'
              this.message.seconds = this.seconds
              this.message.success = 1
              this.showAlert()
              setTimeout(this.buttonActive, this.seconds * 1000)
            })
          },
          (error) => {
            this.message.text = error.message
            this.message.class = 'warning'
            this.message.seconds = this.seconds
            this.message.success = 1
            this.showAlert()
            setTimeout(this.buttonActive, this.seconds * 1000)
          })
          .catch(error => {
            console.log(error)
            this.message.text = 'Disculpe, hubo un error al procesar formulario code[3]'
            this.message.class = 'warning'
            this.message.seconds = this.seconds
            this.message.success = 1
            this.showAlert()
            setTimeout(this.buttonActive, this.seconds * 1000)
          })
      }
    },
    onReset () {
      this.form = {
        employeePhone: null
      }
      this.valid = {
        employeePhone: null
      }
      this.message = {
        text: '',
        class: '',
        success: 0
      }
      this.dismissCountDown = 0
      this.focusElement = null
      this.blurElement = null
      this.formSent = false
    },
    goTo (url) {
      window.open(url, '_blank')
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.message.seconds
    },
    buttonActive () {
      this.formSent = false
    },
    onSlideStart () {
      this.sliding = true
    },
    onSlideEnd () {
      this.sliding = false
    }
  },
  watch: {
    'form.employeePhone': function (newVal, oldVal) {
      this.showLayer = false
    }
  }
}

</script>

<style scoped lang="scss">

  /* DESKTOP */

  .search {
    color: #020247 !important;
  }

  .search .banner {
    max-width: 100%;
    background-image: url("../assets/img/banner-search.png");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  }

  .search .title-regular {
    font-weight: 400;
  }

  .search .title-semibold {
    font-weight: 500;
  }

  .search .title-bold {
    font-weight: 700;
    color: #ff3d00 !important;
  }

  .search .desc-regular {
    font-weight: 400;
  }

  .search .desc-bold {
    font-weight: 700;
  }

  .search .form-control {
    border-bottom: 2px solid rgb(2, 2, 71);
  }

  .search .input-group-text {
    border-bottom: 2px solid rgb(2, 2, 71);
  }

  .search .card-bold-1 {
    font-weight: 700;
    color: #42e8b5 !important;
  }

  .search .card-bold-2 {
    font-weight: 700;
    color: #020247 !important;
  }

  .search .card-semibold-1 {
    font-weight: 500;
    font-size: 27px;
    color: #fff !important;
  }

  .search .card-semibold-2 {
    font-weight: 500;
    font-size: 20px;
    color: #fff !important;
  }

  .search .card-regular {
    font-weight: 400;
    color: #020247 !important;
  }

  .search .btn-primary, .search .btn-primary:hover {
    color: #fff !important;
    background-color: #10069f !important;
  }

  .search .btn-secondary, .search .btn-custom {
    background-color: #10069f !important;
    border-radius: 16px !important;
  }

  .search .btn-custom:hover {
    background-color: #FF3D00 !important;
    border: 0px;
  }

  .search .card {
    padding: 0 0px 28px 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(16, 6, 159, 0.4);
  }

  .search .logo-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(16, 6, 159, 0.4);
  }

  .search .alert-info, .search .alert-warning {
    padding: 18px 16px 2px;
    border-radius: 13px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.23);
    background-color: #020247;
    color: #fff;
    font-size: 0.7rem;
  }

  .search .zoom {
    transition: transform .2s;
  }

  .search .zoom:hover {
    transform: scale(1.03);
  }

  /* MOBILE */

  .search-mobile {
    background-color: #fff;
    color: #020247 !important;
  }

  .search-mobile input {
    background-color: transparent !important;
  }

  .search-mobile .banner-mobile {
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    background-image: url("../assets/img/banner-mobile.png");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  }

  .search-mobile .titlem-regular {
    font-weight: 400;
    line-height: 22px;
    font-size: 16px;
  }

  .search-mobile .titlem-semibold {
    font-weight: 500;
    line-height: 22px;
    font-size: 16px;
  }

  .search-mobile .titlem-bold {
    line-height: 22px;
    font-size: 16px;
    font-weight: 700;
    color: #ff3d00 !important;
  }

  .search-mobile .descm-regular {
    font-weight: 400;
    line-height: 0px;
    font-size: 20px;
  }

  .search-mobile .descm-bold {
    font-weight: 700;
    line-height: 0px;
    font-size: 20px;
  }

  .search-mobile .form-control {
    border-bottom: 2px solid rgb(2, 2, 71);
  }

  .search-mobile .input-group-text {
    border-bottom: 2px solid rgb(2, 2, 71);
  }

  .search-mobile .card-text {
    min-height: 75px;
  }

  .search-mobile .card-row {
    min-height: 110px;
  }

  .search-mobile .card-bold-1 {
    font-weight: 700;
    font-size: 16px;
    color: #42e8b5 !important;
  }

  .search-mobile .card-bold-2 {
    font-weight: 700;
    font-size: 16px;
    color: #020247 !important;
  }

  .search-mobile .card-bold-4 {
    font-weight: 700;
    font-size: 24px;
    color: #020247 !important;
  }

  .search-mobile .card-semibold-1 {
    font-weight: 500;
    font-size: 24px;
    color: #fff !important;
  }

  .search-mobile .card-semibold-2 {
    font-weight: 500;
    font-size: 17px;
    color: #fff !important;
  }

  .search-mobile .card-regular-1 {
    font-weight: 400;
    font-size: 14px;
    color: #020247 !important;
  }

  .search-mobile .card-regular-2 {
    font-weight: 400;
    font-size: 24px;
    color: #020247 !important;
  }

  .search-mobile .btn-primary, .search-mobile .btn-primary:hover {
    font-size: 14px;
    padding: 4px 25px !important;
    color: #fff !important;
    background-color: #10069f !important;
  }

  .search-mobile .btn-secondary, .search-mobile .btn-custom {
    font-size: 14px;
    padding: 4px 60px;
    background-color: #10069f !important;
    border-radius: 16px !important;
  }

  .search-mobile .btn-custom:hover {
    background-color: #FF3D00 !important;
    border: 0px;
  }

  .search-mobile .card {
    padding: 0 0px 28px 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(16, 6, 159, 0.4);
  }

  .search-mobile .logo-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(16, 6, 159, 0.4);
  }

  .search-mobile .alert-info, .search-mobile .alert-warning {
    font-size: 16px;
    padding: 18px 16px 2px;
    border-radius: 13px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.23);
    background-color: #020247;
    color: #fff;
  }

  .carousel-control-next-icon {
    background-image: url("../assets/img/arrow-right.png") !important;
  }

  /* MEDIA QUERIES */

  @media (min-width: 436px) {

    .search-mobile .banner-mobile > .row:first-child {
      padding-top: 3rem !important;
    }

    .search-mobile .banner-mobile > .row:first-child > div {
      margin-top:50px
    }

    /* .search-mobile .banner-mobile .row:nth-child(2) > div {
      margin-top:50px
    } */

    .search-mobile .titlem-regular {
      line-height: 22px;
      font-size: 18px;
    }

    .search-mobile .titlem-semibold {
      line-height: 22px;
      font-size: 18px;
    }

    .search-mobile .titlem-bold {
      line-height: 22px;
      font-size: 18px;
    }

    .search-mobile .descm-regular {
      line-height: 0px;
      font-size: 20px;
    }

    .search-mobile .descm-bold {
      line-height: 0px;
      font-size: 20px;
    }

    .search-mobile .card-text {
      min-height: 80px;
    }

    .search-mobile .card-bold-1 {
      font-size: 18px;
    }

    .search-mobile .card-bold-2 {
      font-size: 18px;
    }

    .search-mobile .card-bold-3 {
      font-size: 24px;
    }

    .search-mobile .card-bold-4 {
      font-size: 26px;
    }

    .search .card-semibold-1 {
      font-size: 24px;
    }

    .search .card-semibold-2 {
      font-size: 17px;
    }

    .search-mobile .card-regular-1 {
      font-size: 18px;
    }

    .search-mobile .card-regular-2 {
      font-size: 26px;
    }

    .search-mobile .btn-primary, .search-mobile .btn-primary:hover {
      font-size: 18px;
      padding: 4px 25px !important;
    }

    .search-mobile .btn-secondary, .search-mobile .btn-custom {
      font-size: 18px;
      padding: 4px 80px;
    }

    .search-mobile .card {
      padding: 0 0px 28px 0;
    }

    .search-mobile .alert-info, .search-mobile .alert-warning {
      font-size: 16px;
      padding: 18px 16px 2px;
    }

  }

  @media (min-width: 576px) {

    .search .banner {
      height: 142px;
    }

    .search .banner .mt-5 {
      margin-top: 0.1rem !important;
    }

    .search .banner .mt-4 {
      margin-top: 0.2rem !important;
    }

    .search .title-regular {
      line-height: 18px;
      font-size: 14px;
    }

    .search .title-semibold {
      line-height: 18px;
      font-size: 14px;
    }

    .search .title-bold {
      line-height: 18px;
      font-size: 14px;
    }

    .search .desc-regular {
      line-height: 18px;
      font-size: 14px;
    }

    .search .desc-bold {
      line-height: 18px;
      font-size: 14px;
    }

    .search .btn-primary {
      font-size: 12px;
      padding: 8px 15px !important;
    }

    .search .btn-secondary {
      font-size: 12px;
      padding: 4px 50px;
    }

    .search .alert-info, .search .alert-warning {
      padding: 5px 5px 2px;
      font-size: 0.7rem;
    }

    .search .card-bold-1 {
      font-size: 14px;
    }

    .search .card-bold-2 {
      font-size: 14px;
    }

    .search .card-bold-3 {
      font-size: 14px;
    }

    .search .card-regular {
      font-size: 14px;
      line-height: 22px;
    }

    .search .card-text {
      min-height:120px;
    }

  }

  @media (min-width: 768px) {

    .search .banner {
      height: 190px;
    }

    .search .banner .mt-5 {
      margin-top: 1rem !important;
    }

    .search .banner .mt-4 {
      margin-top: 0.5rem !important;
    }

    .search .title-regular {
      line-height: 24px;
      font-size: 18px;
    }

    .search .title-semibold {
      line-height: 24px;
      font-size: 18px;
    }

    .search .title-bold {
      line-height: 24px;
      font-size: 18px;
    }

    .search .desc-regular {
      line-height: 24px;
      font-size: 16px;
    }

    .search .desc-bold {
      line-height: 24px;
      font-size: 16px;
    }

    .search .btn-primary {
      font-size: 18px;
      padding: 8px 25px !important;
    }

    .search .btn-secondary {
      font-size: 14px;
      padding: 8px 60px;
    }

    .search .alert-info, .search .alert-warning {
      padding: 18px 16px 2px;
      font-size: 0.9rem;
    }

    .search .card-bold-1 {
      font-size: 14px;
    }

    .search .card-bold-2 {
      font-size: 14px;
    }

    .search .card-bold-3 {
      font-size: 20px;
    }

    .search .card-regular {
      font-size: 14px;
      line-height: 18px;
    }

    .search .card-text {
      min-height:96px;
    }

  }

  @media (min-width: 992px) {

    .search .banner {
      height: 253px;
    }

    .search .banner .mt-5 {
      margin-top: 1.8rem !important;
    }

    .search .banner .mt-4 {
      margin-top: 1.2rem !important;
    }

    .search .title-regular {
      line-height: 32px;
      font-size: 22px;
    }

    .search .title-semibold {
      line-height: 32px;
      font-size: 22px;
    }

    .search .title-bold {
      line-height: 32px;
      font-size: 22px;
    }

    .search .desc-regular {
      line-height: 32px;
      font-size: 20px;
    }

    .search .desc-bold {
      line-height: 32px;
      font-size: 20px;
    }

    .search .btn-primary {
      font-size: 18px;
      padding: 8px 28px !important;
    }

    .search .btn-secondary {
      font-size: 18px;
      padding: 8px 75px;
    }

    .search .alert-info, .search .alert-warning {
      padding: 18px 16px 2px;
      font-size: 1rem;
    }

    .search .card-bold-1 {
      font-size: 18px;
    }

    .search .card-bold-2 {
      font-size: 18px;
    }

    .search .card-bold-3 {
      font-size: 26px;
    }

    .search .card-regular {
      font-size: 18px;
      line-height: 22px;
    }

    .search .card-text {
      min-height:96px;
    }

  }

  @media (min-width: 1200px) {

    .search .banner {
      height: 300px;
    }

    .search .banner .mt-5 {
      margin-top: 2.5rem !important;
    }

    .search .banner .mt-4 {
      margin-top: 1.5rem !important;
    }

    .search .title-regular {
      line-height: 32px;
      font-size: 24px;
    }

    .search .title-semibold {
      line-height: 32px;
      font-size: 24px;
    }

    .search .title-bold {
      line-height: 32px;
      font-size: 24px;
    }

    .search .desc-regular {
      line-height: 32px;
      font-size: 22px;
    }

    .search .desc-bold {
      line-height: 32px;
      font-size: 22px;
    }

    .search .btn-primary {
      font-size: 18px;
      padding: 8px 46px !important;
    }

    .search .btn-secondary {
      font-size: 18px;
      padding: 8px 90px;
    }

    .search .alert-info, .search .alert-warning {
      padding: 18px 16px 2px;
      font-size: 20px;
    }

    .search .card-bold-1 {
      font-size: 18px;
    }

    .search .card-bold-2 {
      font-size: 18px;
    }

    .search .card-bold-3 {
      font-size: 28px;
    }

    .search .card-regular {
      font-size: 18px;
      line-height: 22px;
    }

    .search .card-text {
      min-height:72px;
    }

  }

</style>
